import React from 'react';
import {Container, Menu} from "semantic-ui-react";
import {NavLink, useHistory} from "react-router-dom";

export const Place = () => {

    const history = useHistory();

    return (
        <Menu secondary pointing inverted className={'main-menu'}>
            <Container>
                <Menu.Item
                    as={NavLink}
                    to={'/place/categories'}
                    content={'Categorias'}
                />
                <Menu.Item
                    as={NavLink}
                    to={'/place/courses'}
                    content={'Cursos'}
                />
                <Menu.Item
                    as={NavLink}
                    to={'/place/products'}
                    content={'Produtos'}
                />
                <Menu.Item
                    as={NavLink}
                    to={'/place/orders'}
                    content={'Pedidos'}
                />
                <Menu.Item
                    as={NavLink}
                    to={'/place/responsible'}
                    content={'Responsável'}
                />
                <Menu.Item
                    as={NavLink}
                    to={'/place/params'}
                    content={'Configurações'}
                />
                <Menu.Menu position='right'>
                    <Menu.Item
                        content={'Sair'}
                        onClick={() => {
                            sessionStorage.removeItem('Token')
                            sessionStorage.removeItem('Data')
                            history.push('/users')
                        }}
                    />
                </Menu.Menu>
                {/*<Menu.Item*/}
                {/*    as={NavLink}*/}
                {/*    to={'/place/peoples'}*/}
                {/*    content={'Pessoas'}*/}
                {/*/>*/}
            </Container>
        </Menu>
    );
}